import { Div } from 'client/widget-components/basicComponents';
import styled, { css } from 'styled-components';
import { DesignStyle } from '../../../types';
import {
    bodyCustomStyles,
    titleCustomStyles,
} from '../../ContainerQueryStyles';

const bodyTypography = css`
    color: ${({ theme }) => theme.bookerPrimaryColor};
    font-weight: 350;
    letter-spacing: 0px;
`;

// Layout mixins
const flexColumn = css`
    display: flex;
    flex-direction: column;
`;

const flexRow = css`
    display: flex;
    align-items: flex-start;
`;

// Reset and base styles
const resetStyles = css`
    margin: 0;
    padding: 0;
    box-sizing: border-box;
`;

export const Card = styled.li`
    border: 1px solid ${({ theme }) => theme.bookerPrimaryColor};
    border-radius: 8px;
    padding: 24px;
    background: ${({ theme }) => theme.bookerSecondaryColor} !important;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;

    &:hover {
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
        transform: translateY(-1px);
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &:active {
        transform: translateY(0px);
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    }
`;

export const SkeletonCard = styled(Card)`
    cursor: default;
`;

export const StepItemsList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 16px;
    list-style: none;
    padding-inline: 0;
    padding-block: 32px;
    margin-block: 1px;
    text-align: start;
`;

export const CardContent = styled.div`
    ${flexRow}
    gap: 16px;
`;

export const MainContent = styled.div`
    ${flexColumn}
    gap: 12px;
    flex: 1;
`;

export const EventTitle = styled.h5`
    #dmRoot #dm && {
        ${resetStyles}
        color: ${({ theme }) => theme.bookerPrimaryColor};
        margin: 0;
        flex: 1;
        font-weight: 550;
        letter-spacing: 0px;
    }

    #dm .${DesignStyle.SITE_THEME} && {
        color: ${({ theme }) => theme.bookerPrimaryColor};
    }

    ${titleCustomStyles}
    color: ${({ theme }) => theme.bookerPrimaryColor} !important;
`;

export const EventSubTitle = styled.span`
    ${resetStyles}
    ${bodyTypography}
    flex-shrink: 0;

    ${bodyCustomStyles}
    color: ${({ theme }) => theme.bookerPrimaryColor} !important;
    margin-block: 8px 32px;
    display: block;
`;

export const EventDescription = styled.p`
    ${resetStyles}
    ${bodyTypography}
    line-height: 1.5;

    ${bodyCustomStyles}
`;

export const bookerTitleText = styled.span`
    color: ${({ theme }) => theme.bookerPrimaryColor} !important;
`;

export const EventDuration = styled.div`
    && {
        ${resetStyles}
        ${bodyTypography}
        ${bodyCustomStyles}
    }
`;

export const OuterContainerBase = styled(Div)`
    display: flex;
    flex-direction: column;
    padding-inline: 32px;
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.bookerBackgroundColor};
    border-color: ${({ theme }) => theme.bookerPrimaryColor};
    color: ${({ theme }) => theme.bookerPrimaryColor};
    overflow: auto;
    height: 100%;
`;

export const Container = styled.div`
    max-width: 820px;
    width: 100%;
    margin: 0 auto;
`;

export const GroupedEventsTitle = styled.div`
    position: sticky;
    top: 0;
    font-weight: 550;
    letter-spacing: 0px;
    z-index: 1;
    margin-block-start: 32px;
    display: flex;
    flex-direction: column;
`;
